import React, { useState } from 'react';
import { faqs } from '../mock/mockData';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-white to-rose-50 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-rose-900 mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-lg text-gray-600">
            Respostas às questões mais comuns sobre o acompanhamento psicológico.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className="bg-white border border-rose-200 rounded-2xl px-6 shadow-sm hover:shadow-md transition-all duration-300 data-[state=open]:border-rose-400 data-[state=open]:shadow-lg"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6 text-lg font-semibold text-rose-800 hover:text-rose-600">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6 text-base">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional Help */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-white border border-rose-200 rounded-2xl px-8 py-6 max-w-2xl shadow-md">
            <p className="text-gray-700 mb-4">
              Tem outras questões? Não hesite em contactar-me.
            </p>
            <button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center gap-2 text-rose-600 font-semibold hover:text-rose-500 transition-colors"
            >
              Entre em Contacto
              <ChevronDown className="h-4 w-4 rotate-[-90deg]" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
